import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

class Hero {
  constructor($el) {
    this.$el = $el;
    this.$inner = this.$el.find('[data-hero="inner"]');

    this.init();
  }

  init = () => {
    this.setInitialScale();

    this.tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.$el,
        start: "center center",
        end: "+=100%",
        scrub: 1,
        pin: true,
        invalidateOnRefresh: true,
      },
    });

    this.tl.to(this.$inner, {
      scale: 1,
      ease: "none",
    }, 0);
  }

  setInitialScale = () => {
    const viewportWidth = window.innerWidth;
    const isSm = viewportWidth >= 576;
    const isXXXL = viewportWidth >= 1920;

    let padding = 0;

    if(isSm && !isXXXL) {
       padding = (viewportWidth * 0.025) + 12
    }
    else if(isXXXL) {
       padding = (viewportWidth * 0.05) + 12
    }

    else {
       padding = 12
    }
    const scale = (viewportWidth - 2 * padding) / viewportWidth;

    gsap.set(this.$inner, { scale });
  }

  destroy = () => {
    this.tl?.scrollTrigger?.kill();
    this.tl?.kill();
  }
}

export default Hero;

